import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HttpClientModule } from '@angular/common/http';

import { QuickLinksFloatingComponent } from './quick-links-floating/quick-links-floating.component';
import { QuickLinksSearchModalComponent } from './quick-links-search-modal/quick-links-search-modal.component';
import { DynamicSearchDialogComponent } from './dynamic-search-dialog/dynamic-search-dialog.component';
import { ExternalService } from '../../services/external.service';
import { PropertiesSearchService } from '../../services/properties-search.service';

@NgModule({
  declarations: [
    QuickLinksFloatingComponent,
    QuickLinksSearchModalComponent,
    DynamicSearchDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    HttpClientModule
  ],
  exports: [
    QuickLinksFloatingComponent
  ],
  providers: [
    ExternalService,
    PropertiesSearchService
  ]
})
export class QuickLinksModule { }
